const HUNDREDTHS = 100
const BASIS = 10000

const percentHundredths = percent => {
  const n = parseFloat(percent)
  return Number.isFinite(n) ? Math.round(n * HUNDREDTHS) : 0
}

export const discountedCents = (cents, percent) =>
  Math.floor((cents * (BASIS - percentHundredths(percent)) + BASIS / 2) / BASIS)

export const amountOffCents = (cents, amountCents) => Math.max(cents - (amountCents ?? 0), 0)

export const formatCents = (cents, currency = 'USD') =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100)
